/**
 * 工具方法
 */
const utils = {
    // 判断是否为空
    isEmpty(value) {
        return [null, undefined, ''].includes(value);
    },
    // 数组对象的键转成一个对象的值
    arrToObj(arr, key, value) {
        const obj = {};
        arr.forEach(item => {
            obj[item[key]] = item[value];
        })
        return obj;
    },
    // 将数组的每一项key换成另一个对象的值
    keyToValue(arr, obj) {
        return arr.map((item) => {
            return Object.keys(obj).reduce((newData, key) => {
                const newKey = obj[key] || key;
                newData[newKey] = item[key];
                return newData;
            }, {})
        })
    },
    formatMoney(num, decimal = 2) {
        return Number(num).toFixed(decimal);
    },
    //判断设备是移动端还是pc端
    isMobile() {
        const devices = ["phone", "pad", "pod", "iPhone", "iPod", "ios", "iPad", "Android", "Mobile", "BlackBerry", "IEMobile", "MQQBrowser", "JUC", "Fennec", "wOSBrowser", "BrowserNG", "WebOS", "Symbian", "Windows Phone"];
        const userAgentInfo = navigator.userAgent;
        const isMobile = devices.some(function (device) {
            return userAgentInfo.indexOf(device) > 0;
        });
        return isMobile
    }

}
export default utils;